export default __webpack_public_path__ + "static/media/youtube-icon.c2200a26.svg";